import React from 'react';

import {
    CheckboxGroup,
    CheckboxGroupProps,
} from 'reactComponents/CheckboxGroup/CheckboxGroup';

import { BasicField, BasicFieldProps } from './_BasicField';

// TODO: make field wrapper helper
export const FieldCheckboxGroup = (
    props: Omit<CheckboxGroupProps & BasicFieldProps, 'value' | 'control'>,
) => <BasicField control={CheckboxGroup} {...props} />;
